// extracted by mini-css-extract-plugin
module.exports = {"input":"input-37Jt2","button":"button-3S22v"};